import { Step } from '../model/checkoutModel';
import { checkoutSteps } from './checkoutSteps';

export const getCheckoutStepUrl = (checkoutRoute: string, step?: Step) => {
	if (!step) {
		return '';
	}
	return step === checkoutSteps[0] ? checkoutRoute : `${checkoutRoute}#${step}`;
};
